module.exports = __webpack_public_path__ + "img/CH.86f3d044.webp";